import _ from '@/utils/lodash-optimized'
import React from 'react'
import { NON_CLINICAL_ROLES } from 'shared_src/dictionaries/roles/compassion.js'

import Statuses from '../../../../lib/Codes/ActionStatuses'
import {
  PractitionerSelectInput,
  bindTargetMixin,
  makeAutobindedInput,
  DateInput,
  SelectInput,
  TextAreaInput,
  CheckboxInput
} from '../../../shared/FormBuilder'

import './styles'
import { ActionDescription } from './ActionDescription'

class ActionForm extends bindTargetMixin(React.Component) {
  constructor (props) {
    super(props)
    this.state = {
      value: props.value,
      openDetails: false
    }
    this.changeInProgress = this.changeInProgress.bind(this)
    this.changeNotStarted = this.changeNotStarted.bind(this)
    this.handleOpenDetail = this.handleOpenDetail.bind(this)
    this.handlePractitionerSelect = this.handlePractitionerSelect.bind(this)
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    this.updateProps(nextProps)
  }

  updateProps (props) {
    const { dueDate } = props.value

    this.setState({
      value: {
        ...props.value,
        dueDate
      }
    })
  }

  handleOpenDetail () {
    this.setState({
      openDetails: !this.state.openDetails
    })
  }

  handlePractitionerSelect (value) {
    this.setInputValue('.assignee', value)
    if (value && _.isEqual(value.id, this.props.currentUser.id)) {
      this.setInputValue('.status', 'in-progress')
    } else {
      this.setInputValue('.status', 'not-started')
    }
  }

  renderDetails () {
    const { currentUser } = this.props
    const statuses = _.isEqual(
        this.state.value?.assignee?.id ?? {},
      currentUser.id
    )
      ? Statuses.defaultAssignee
      : Statuses.all

    const userRole = currentUser.role[0].code.text

    const isBroker = [ 'broker_access', 'csr_agent' ].includes(userRole)

    return (
      <div className='action-details row'>
        <div className='col-xs-6'>
          <PractitionerSelectInput
            name='assignee'
            label='Assignee'
            onChange={this.handlePractitionerSelect}
            filterFn={(practitioners) => {
              if (isBroker) {
                return practitioners.filter(p => NON_CLINICAL_ROLES.includes(p.role?.[0]?.code?.text))
              }

              if (typeof this.props.nonClinicalIssue === 'undefined') {
                return practitioners
              }

              if (this.props.nonClinicalIssue) {
                return practitioners
              }

              return practitioners.filter(p => ![ 'broker_access', 'csr_agent' ].includes(p.role?.[0]?.code?.text))
            }}
          />
        </div>
        <div className='col-xs-6'>
          <SelectInput
            disabled={
              (this.state.value.assignee && this.state.value.assignee.id) !==
              currentUser.id
            }
            name='status'
            noSort
            label='Status'
            options={statuses}
            required
          />
        </div>
        <div className='col-xs-6'>
          <DateInput
            name='dueDate'
            label='Action Due Date'
          />
        </div>
        <div
          className='col-xs-6'
          style={{ marginTop: '2.5rem' }}
        >
          <CheckboxInput
            name='urgent'
            label='Urgent'
          />
        </div>
        <div className='col-xs-12'>
          <TextAreaInput
            name='comment'
            label='Comment'
          />
        </div>
      </div>
    )
  }

  changeInProgress () {
    const newState = this.state.value
    newState.status = 'in-progress'
    return newState
  }

  changeNotStarted () {
    const newState = this.state.value
    newState.status = 'not-started'
    return newState
  }

  componentDidMount () {
    const { currentUser } = this.props
    const {
      value: { assignee, isExisting }
    } = this.state
    const mappedCurrentUser = {
      id: currentUser.id,
      display: currentUser.display
    }

    if (
      (!assignee || !assignee.id || currentUser.id !== assignee.id) &&
      !isExisting
    ) {
      this.setInputValue('.assignee', mappedCurrentUser)
      this.setInputValue('.status', 'in-progress')
    }
  }

  setInputValue (inputPath, newVal) {
    super.setInputValue(inputPath, newVal, () => {
      const changeableStatus =
          this.state?.value?.status === 'not-started' ||
          this.state?.value?.status === 'in-progress'
      if (inputPath.includes('assignee') && changeableStatus) {
        if (
          !_.isNil(newVal) &&
          _.isEqual(newVal.id, this.props.currentUser.id)
        ) {
          this.setState({ value: this.changeInProgress() })
        } else {
          this.setState({ value: this.changeNotStarted() })
        }
      }
    })
  }

  render () {
    const {
      value: { dueDate, description },
      openDetails
    } = this.state
    return (
      <div className='action'>
        <div className='row bottom-xs'>
          <ActionDescription
            dueDate={dueDate}
            description={description}
            isOpen={openDetails}
            onOpen={this.handleOpenDetail}
            inCarePlan
          />
        </div>

        {openDetails ? this.renderDetails() : null}
      </div>
    )
  }
}

export default makeAutobindedInput(ActionForm)
